import Phone from '@letsdial/phone'
import { getCurrentInstance, onMounted, onUnmounted } from 'vue'

let phoneInstance: any

interface LetsDialPhone {
  on: (event: string, callback: (...args: any[]) => void) => void
  off: (event: string, callback: (...args: any[]) => void) => void
  connect: (username: string, password: string) => void
  hangup: () => void
  hold: () => void
  unHold: () => void
  sendDtmf: (tone: string) => void
  joinConference: (callID: string | number, serverIp: string) => void
}

export default function useLetsDialPhone() {
  const instance = getCurrentInstance()

  if (!phoneInstance) {
    phoneInstance = instance?.appContext.config.globalProperties.$phone as LetsDialPhone
    
    if (!phoneInstance) {
      console.warn('Phone instance not found in globalProperties, creating fallback instance.')
      // @ts-expect-error: Fallback if global instance is missing
      phoneInstance = new Phone(import.meta.env.VITE_PHONE_URL)
    }
  }

  const phone: LetsDialPhone = phoneInstance

  const listeners: Array<{
    event: string
    callback: (...args: any[]) => void
  }> = []

  /**
   * Register a listener that will be automatically cleaned up on unmount.
   * IMPORTANT: Use named functions to ensure proper removal.
   */
  const listen = (event: string, callback: (...args: any[]) => void) => {
    listeners.push({ event, callback })
    // If called after mount, register immediately
    if (instance?.isMounted) {
      phone.on(event, callback)
    }
  }

  onMounted(() => {
    listeners.forEach(({ event, callback }) => {
      phone.on(event, callback)
    })
  })

  onUnmounted(() => {
    listeners.forEach(({ event, callback }) => {
      phone.off(event, callback)
    })
    // Clear local registry
    listeners.length = 0
  })

  return {
    phone,
    listen,
  }
}
